import { Directive } from '@angular/core';

@Directive({
  selector: '[stopEventPropagation]',
})
export class StopEventPropagationDirective {

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }
}
